<div class="qq-summary__info" *ngIf="policyInfo && keys.policyInfo">
  <app-site-content [key]="keys.policyInfo" class="info" [data]="templateData">
  </app-site-content>
</div>

<div class="qq-summary__info" *ngIf="contactUs">
  <app-site-content key="QuickQuoteSummary.ContactUs">
  </app-site-content>
</div>

<div class="qq-summary__info document-links" *ngIf="documentLinks && keys.documentLinks">
  <app-site-content [key]="keys.documentLinks">
  </app-site-content>
</div>

<div class="qq-summary__info" *ngIf="policyBenefits && keys.policyBenefits">
  <app-site-content [key]="keys.policyBenefits">
  </app-site-content>
</div>